import React, { useState, ReactNode } from 'react';

export type SidebarItemProps = {
  active?: boolean;
  onClick?: () => void;
  icon?: ReactNode;
  children?: ReactNode;
  count?: number;
  subtitle?: ReactNode;
  indent?: number;
};

export function SidebarItem({
  active,
  onClick,
  icon,
  children,
  count,
  subtitle,
  indent,
}: SidebarItemProps) {
  const [hover, setHover] = useState(false);
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: 'flex', alignItems: 'center', gap: 10,
        padding: '8px 10px',
        paddingLeft: 10 + (indent || 0),
        borderRadius: 8,
        background: active ? 'var(--accent-fill)' : hover ? 'var(--bg-fill-1)' : 'transparent',
        color: active ? 'var(--accent)' : 'var(--fg-primary)',
        textAlign: 'left', width: '100%',
        transition: 'all var(--dur-fast) var(--ease-out)',
        fontSize: 14, fontWeight: active ? 600 : 500, letterSpacing: '-0.16px',
        border: 0, cursor: 'pointer',
      }}
    >
      <span style={{ display: 'inline-flex', flex: '0 0 auto' }}>{icon}</span>
      <span
        style={{
          flex: 1, minWidth: 0,
          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
        }}
      >
        {children}
        {subtitle && (
          <div
            className="t-caption1"
            style={{ color: 'var(--fg-tertiary)', fontWeight: 400, marginTop: 1 }}
          >
            {subtitle}
          </div>
        )}
      </span>
      {count != null && (
        <span
          style={{
            fontSize: 11, fontWeight: 600,
            color: active ? 'var(--accent)' : 'var(--fg-tertiary)',
            background: active ? 'rgba(255,255,255,.4)' : 'transparent',
            padding: '1px 6px', borderRadius: 999,
          }}
        >
          {count}
        </span>
      )}
    </button>
  );
}

export default SidebarItem;
